import { render, staticRenderFns } from "./JobListItem.vue?vue&type=template&id=60bf98ba&"
import script from "./JobListItem.vue?vue&type=script&lang=js&"
export * from "./JobListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports